
// -------------------------------------------
// Подсказка в чекбоксах в фильтрах, а также в списках выбора цвета в карточк товара
//
// Как использовать: new Tip();
// tip.run();  //Дальше конструктор все сделает сам
// -------------------------------------------

class Tips{
  constructor(){

    this.pathToJSON = '/assets/template/json/filters-tips.json';
    this.$winTip = null;
    // В анимации используется setTimeout. Анимация активируется при клике. Если быстро покликать, то могут быть глюки в анимации. Чтобы их не было, нужно очищать timeout. Чтобы очищать timeout, нужно где-то его хранить. Данная переменная нужна для этой цели
    this.animationTimeout = null;
    this.positionTimeout = null;
   
    this.run();

  }

  run(){
    // Пытаемся загрузить JSON с подсказками из файла
    const host = this;
    $.getJSON(this.pathToJSON, [], function (tipsData) {
                
      host.code(tipsData);
      /*
      switch (pageType) {
          case PAGE_TYPE_PRODUCT:
            host.productCode(tipsData);
          break;
          case PAGE_TYPE_CATALOG:
            host.catalogCode(tipsData);
          break;
      }*/

      // Устанавливаем $winTip и добавляем его на страницу
      host.$winTip = $('<div class="wintip"><span class="wintip__btn-close"></span><div class="wintip__content"></div></div>').appendTo('body');

      // Добавляем обработчик для клика по подсказке
      $(document).on('click', '.filter-option__tip', function (e) {
        host.handleClickTip(host, e, $(this));
      });

      // Вешаем обработчик на документ - клик по пустому месту должен скрывать подсказку
      $(document).on('click', function (e) {
        host.handleClickEmptySpace(e);
      });
    }
    );
  }

  //Обработчик клика по подсказке
  handleClickTip(host, e, $this){
    // На странице товара есть стилизованный список с цветами, там тоже подсказки. Но элементы списка - ссылки. И если нажать на вызов подсказки, будет переход по ссылке. preventDefault отменяет переход
    e.preventDefault();

    //let $this = $(this);
    clearTimeout(this.animationTimeout);

    $('.filter-option__tip.active').not(this).removeClass('active');
    $this.toggleClass('active');

    if ($this.hasClass('active')) {
        clearTimeout(this.positionTimeout);
        this.$winTip.find('.wintip__content').html($this.find('.filter-option__tip-content').html());

        this.$winTip.addClass('visible');
        // Я заметил, что если делать без timeout'а, то иногда неправильно определяется ширина winTip. Из-за этого неправильно выставляется положение на странице
        // Я вызываю setWinTipPosition 2 раза, чтобы пользователь не ждал 350 ms, чтобы увидеть winTip
        this.setWinTipPosition($this);
        this.positionTimeout = setTimeout(function () {
            host.setWinTipPosition($this);
        }, 350);
    } else {
        this.hideTip();
    }
  }

  handleClickEmptySpace(e){
    let $target = $(e.target);
    if (
        // Подсказка должна быть видна
        this.$winTip.hasClass('visible') &&
        // Клик не должен быть по кнопке для вызова подсказки (или ее содержимых элементов)
        !$target.closest('.filter-option__tip').length && !$target.hasClass('filter-option__tip') &&
        // Клик не должен быть по самой подсказке (или ее содержимых элементов, исключение - кнопка для закрытия подсказки (крестик))
        (!$target.closest('.wintip').length || $target.hasClass('wintip__btn-close')) && !$target.hasClass('wintip')
    ) {
        $('.filter-option__tip.active').removeClass('active');
        this.hideTip();
    }
  }

  // Функция для установки позиции подсказки
  setWinTipPosition($tip) {
    let positionTop = $tip.offset().top;
    let positionLeft = $tip.offset().left;
    if (window.innerWidth <= 1200) {
        let winTipWidth = $winTip.outerWidth();
        positionLeft = positionLeft - winTipWidth + 60;
    }
    this.$winTip.css({
        'top': positionTop,
        'left': positionLeft,
    });
  }

  // Функция для скрывания подсказки
  hideTip() {
    this.$winTip.removeClass('visible');
    const host = this;
    this.animationTimeout = setTimeout(function () {
      host.$winTip.css({
              'top': '',
              'left': '',
          });
      },
      // Если будешь менять это значение, то поменяй еще и у transition opacity в SASS
      350);
  }

  //Метод для замены в подклассах, который делает работу на странице продукта или в каталоге
  code(tipsData){
    //console.log("super code");
  }

}

class TipsProduct extends Tips{
  //
  // fltrVal_selector - селектор элемента, в котором есть код цвета, пример: data-value="RAL 3005"
  //
  constructor(fltrVal_selector){
    super();
    this.fltrSelector = fltrVal_selector;
    //console.log("TipsProduct constructor");
  }
  // подсказка на странице товара
  code(tipsData){
    //console.log("product code");
    let key = 'msoption|cvet';
    // Для страницы товара нужны именно цвета
    if (!tipsData[key]
        || Object.keys(tipsData[key]).length === 0
        || Object.getPrototypeOf(tipsData[key]) !== Object.prototype) {
        return;
    } else {
        for (const value in tipsData[key]) {
            // Ищем опцию с нужным ключом
            let $fltrVal = $(this.fltrSelector + '[data-value="' + value + '"]');

            // Если нашли, то...
            if ($fltrVal.length) {
                let tipContent;

                // Тут может быть либо путь к картинке, либо hex-код цвета
                let cssBgValue;

                if (Array.from(tipsData[key][value]['visual'])[0] == '#') {
                    cssBgValue = tipsData[key][value]['visual'];
                } else {
                    cssBgValue = 'url(\'' + tipsData[key][value]['visual'] + '\')';
                }

                tipContent = '<div class="wintip__visual-text"><div class="wintip__visual" style="background: ' + cssBgValue + '"></div><div class="wintip__text-wrap"><strong class="wintip__header">' + value + '</strong><span class="wintip__text">' + tipsData[key][value]['text'] + '</span></div></div>';

                // Добавляем подсказку
                let $tip = $('<div class="filter-option__tip"><span class="filter-option__tip-icon"></span><div class="filter-option__tip-content">' + tipContent + '</div></div>');
                $fltrVal.append($tip);
            }
        }
    }
  }
}

class TipsCatalog extends Tips{
  // keySelector - элемент, в котором есть data-key="msoption|cvet" и подобные значения
  // valSelector - элемент, в котором есть data-value="RAL 1014" и подобные значения
  constructor(keySelector, valSelector){
    super();
    this.keySelector = keySelector;
    this.valSelector = valSelector;
    //console.log("TipsCatalog constructor");
  }
  // подсказка на странице каталога
  code(tipsData){
    //console.log("catalog code");
    // Ищем фильтр с нужным ключом
    for (const keyFilter in tipsData) {
      //listing__filter-block
      let $fltr = $(this.keySelector + '[data-key="' + keyFilter + '"]');
      // Если нашли, то...
      if ($fltr.length) {
          for (const value in tipsData[keyFilter]) {
              //console.log(keyFilter);
              // Ищем опцию с нужным ключом
              let $fltrVal = $fltr.find(this.valSelector + '[data-value="' + value + '"]');
              
              // Если нашли, то...
              if ($fltrVal.length) {
                  // Определяем внутренний контент подсказки: это либо текст, либо (в некоторых случаях, например, для опции цвет) html-код
                  let tipContent;
                  if (keyFilter == 'msoption|cvet') {
                      // Тут может быть либо путь к картинке, либо hex-код цвета
                      let cssBgValue;

                      if (Array.from(tipsData[keyFilter][value]['visual'])[0] == '#') {
                          cssBgValue = tipsData[keyFilter][value]['visual'];
                      } else {
                          cssBgValue = 'url(\'' + tipsData[keyFilter][value]['visual'] + '\')';
                      }

                      tipContent = '<div class="wintip__visual-text"><div class="wintip__visual" style="background: ' + cssBgValue + '"></div><div class="wintip__text-wrap"><strong class="wintip__header">' + value + '</strong><span class="wintip__text">' + tipsData[keyFilter][value]['text'] + '</span></div></div>';
                  } else {
                      tipContent = tipsData[keyFilter][value];
                  }

                  // Добавляем подсказку
                  let $tip = $('<div class="filter-option__tip"><span class="filter-option__tip-icon"></span><div class="filter-option__tip-content">' + tipContent + '</div></div>');
                  $fltrVal.append($tip);
              }
          }
      }
    }
  }
}

export {TipsCatalog, TipsProduct};
